import { render, staticRenderFns } from "./ServicecalenderIndex.vue?vue&type=template&id=6810b8cc&scoped=true"
import script from "./ServicecalenderIndex.vue?vue&type=script&lang=js"
export * from "./ServicecalenderIndex.vue?vue&type=script&lang=js"
import style0 from "./ServicecalenderIndex.vue?vue&type=style&index=0&id=6810b8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6810b8cc",
  null
  
)

export default component.exports